import React from "react";
import { FaCheckSquare as FaCheckSquareIcon, FaRegCheckSquare as FaRegCheckSquareIcon } from "react-icons/fa";

const FaCheckSquare = FaCheckSquareIcon as React.ElementType;
const FaRegCheckSquare = FaRegCheckSquareIcon as React.ElementType;

const Checkbox = ({
	checked,
	onChange,
}: {
	checked: boolean;
	onChange: (checked: boolean) => void;
}) => {

	return (
		<button onClick={() => onChange(!checked)} className="text-blue-600">
			{checked ? <FaCheckSquare size={24} /> : <FaRegCheckSquare size={24} />}
		</button>
	);
};

export default Checkbox;
